module.exports = __webpack_public_path__ + "img/5-5.e5375ce9.svg";